module.exports = __webpack_public_path__ + "static/media/02-rules.870e9389.png";